<template>
    <tr>
        <td :class="{'text-danger': entry.state === 'open'}">{{ entry.date }}</td>
        <td :class="{'text-danger': entry.state === 'open'}">{{ entry.value }}</td>
        <td :class="{'text-danger': entry.state === 'open'}">{{ entry. text }}</td>
    </tr>
</template>

<script>
export default {
    name: 'PaymentHistoryEntry',
    props: {
        entry: {
            type: Object
        },
    },
}
</script>
